// ==============================|| ETAG TYPES  ||============================== //

export interface EtagInterface {
  entity: EtagEntityList;
  etag: string;
}

export type EtagEntityList = EaiEtagEntityList | DispatcherEtagEntityList;

export enum EaiEtagEntityList {
  EMS_PARTY = 'emsParty',
  EMS_MEMBER_ACCOUNT = 'emsMemberAccount',
  MARKET_PARTICIPANT = 'marketParticipant',
  USER = 'user',
  DELIVERY_POINT = 'deliveryPoint',
  BALANCE_GROUP = 'balanceGroup',
  DEVICE = 'device',
  DELIVERY_CONTRACT = 'deliveryContract'
}

export enum DispatcherEtagEntityList {
  OPERATION_EVENT = 'operationEvent'
}
